
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.334","height":"24.001"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Number_Formatter","data-name":"Number Formatter","transform":"translate(.75 .75)"}},[_c('g',{attrs:{"id":"Group_18565","data-name":"Group 18565"}},[_c('g',{attrs:{"id":"Group_18566","data-name":"Group 18566","fill":"none","stroke":"#6d7f93","stroke-linecap":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_927","data-name":"Path 927","d":"M19.262 21.412v2.374a1.366 1.366 0 01-1.362 1.366H1.866A1.366 1.366 0 01.5 23.786V7.755A1.366 1.366 0 011.866 6.39h2.707","transform":"translate(-.5 -2.65)","stroke-miterlimit":"10"}}),_c('path',{attrs:{"id":"Path_928","data-name":"Path 928","d":"M24.311 19.262H8.28A1.365 1.365 0 016.915 17.9V1.866A1.365 1.365 0 018.28.5h16.031a1.366 1.366 0 011.365 1.366V17.9a1.365 1.365 0 01-1.365 1.362z","transform":"translate(-2.842 -.5)","stroke-miterlimit":"10"}}),_c('path',{attrs:{"id":"Path_929","data-name":"Path 929","d":"M21.931 15.438v-5.212A4.349 4.349 0 0120.9 11.9","transform":"translate(-7.945 -4.05)","stroke-linejoin":"round"}}),_c('line',{attrs:{"id":"Line_396","data-name":"Line 396","x2":"2.071","transform":"translate(12.95 11.387)","stroke-linejoin":"round"}})])])])])
          )
        }
      }
    